import React, { useEffect, useRef } from "react";
import { useSettings } from "@/context/SettingsContext";

// Google AdSense slot. Renders only when AdSense is enabled in admin settings.
export default function AdSlot({ slot = "", className = "", label = "Advertisement", style }) {
  const { settings } = useSettings();
  const ref = useRef(false);
  const enabled = settings?.adsense_enabled && settings?.adsense_client;

  useEffect(() => {
    if (enabled && !ref.current) {
      ref.current = true;
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {}
    }
  }, [enabled]);

  if (!enabled) {
    return (
      <div
        data-testid="ad-slot-placeholder"
        className={`flex items-center justify-center rounded-lg border border-dashed border-white/15 bg-white/[0.02] text-white/30 ${className}`}
        style={{ minHeight: 90, ...style }}
      >
        <span className="eyebrow">{label} · AdSense ready</span>
      </div>
    );
  }

  return (
    <ins
      className={`adsbygoogle block ${className}`}
      data-testid="ad-slot"
      style={{ display: "block", ...style }}
      data-ad-client={settings.adsense_client}
      data-ad-slot={slot}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
}
